import React from 'react'
import "./App.css";

function TaskManagerManagerApp() {
    return (
        <div className="App">
            <div style={{ display: "flex", flexDirection: "row" }}>
                Task Manager Widget here.
            </div>
        </div>
    );
}

export default TaskManagerManagerApp;
